import { Field, useFormikContext } from "formik";
import React, { FC } from "react";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { requiredValidation } from "../../../utilities/Validation";
import Label from "../../label/label";
import { WizardStepLayout } from '../../wizard/wizard-summary-layout';
import TimeField from "../../timeField/timeField";

interface TimeStepProps {
    onBack: (event: any) => void;
    onNext: (event: any) => void;
    filterModalTrigger: string;
}

const TimeStep: FC<TimeStepProps> = ({ onBack, onNext, filterModalTrigger }) => {
    const { translate } = useLocale();
    const { errors, values } = useFormikContext<any>();

    return <WizardStepLayout onBack={!filterModalTrigger ? onBack : undefined} onNext={(event) => { if (values.time) { onNext(event) }}} nextDisabled={!values.time}>
        <span className={`mb-3 text-portal-blue-primary text-xl font-semibold`}>
            {translate.byKey(TranslationKeys.selectTimeFilter)}
        </span>

        <div className="mt-1">
            <div className="flex flex-row justify-between" id='timeLabel'>
                <Label
                    required
                    htmlFor="time"
                    className="text-xs text-gray-600 mt-1">{translate.byKey(TranslationKeys.time)}:</Label>
                {errors.time ? <span className='text-red-600 text-xs pr-6'>{errors.time}</span> : null}
            </div>
            <div className="flex flex-row justify-between w-64" id='timeId'>
                <Field
                    valueName="time"
                    name="time"
                    placeholder={"--:--"}
                    component={TimeField}
                    validate={(value) => requiredValidation(value, translate)} />
            </div>
        </div>
    </WizardStepLayout>
}

export default TimeStep;